import { GridColumn } from "@progress/kendo-react-grid";
import { SortDescriptor } from "@progress/kendo-data-query";
import { useNavigate } from "react-router-dom";
import { protectedResources } from '../../authConfig';
import {BaseGrid,ButtonHelper} from '../../components/KendoGrid/BaseGrid';

const LabList = () => {
    const navigate = useNavigate();

    const alphabeticalSort = [{
        field: "FacilityName",
        dir: "asc"
    } as SortDescriptor];

    return (
        <>
            <BaseGrid intialSort={alphabeticalSort} verb={'POST'} pageTitle='Lab List' endpoint={protectedResources.apiLab.endpoint + "KendoGridRead"} redirectUrl="/lab-manage/"
            button={[{ onClick: () => { { navigate("/lab-manage"); } }, buttonText: 'Create New Lab' } as ButtonHelper]} >
                <GridColumn field="facilityName" title="Facility Name"/>
                <GridColumn field="addressLine1" title="Address Line 1"/>
                <GridColumn field="addressLine2" title="Address Line 2"/>
                <GridColumn field="city" title="City"/>
                <GridColumn field="state" title="State"/>
                <GridColumn field="postalCode" title="Postal Code"/>
            </BaseGrid>
        </>
    );
}

export default LabList;